import { render, staticRenderFns } from "./productcode_management.vue?vue&type=template&id=96251da8&scoped=true"
import script from "./productcode_management.vue?vue&type=script&lang=js"
export * from "./productcode_management.vue?vue&type=script&lang=js"
import style0 from "./productcode_management.vue?vue&type=style&index=0&id=96251da8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96251da8",
  null
  
)

export default component.exports